<template>
	<div class="content animated fadeIn">
		<div class="top">
			<div class="top-row">
				<img src="../assets/images/back.png"
					alt=""
					@click="backPrev"/>
				<div>设置</div>
			</div>
		</div>
		<div class="main">
			<div class="setItem"
				@click="jumpToChangePwd">
                <div class="left">
                    <img src="../assets/images/mima.png" alt="">
                    <span>修改密码</span>
                </div>
				<img src="../assets/images/right.png"
					alt="">
			</div>
            <div class="setItem"
				@click="jumpToPreventEmail">
                <div class="left">
                    <img src="../assets/images/email-wh.png" alt="">
                    <span>邮箱维护</span>
                </div>
				<img src="../assets/images/right.png"
					alt="">
			</div>
			<!-- <div class="setItem"
				@click="goFeedback">
				<span>意见反馈</span>
				<img src="../assets/images/right.png"
					alt="">
			</div> -->
			<div class="setItem">
                <div class="left" @click="handleAboutUs">
                    <img src="../assets/images/guanyuwomen.png" alt="">
                    <span>关于我们</span>
                </div>
				<img src="../assets/images/right.png"
					alt="">
			</div>
			<!-- <div class="setItem"
				@click="logout">
				<span>退出登录</span>
				<img src="../assets/images/right.png"
					alt="">
			</div> -->
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      // changePwdUrl:'',
      // emailPreserveUrl:''
    };
  },
  mounted() {
    // this.changePwdUrl=changePwdUrl
    // this.emailPreserveUrl=emailPreserveUrl
  },
  methods: {
    backPrev() {
      this.$router.go(-1);
    },
    jumpToChangePwd(){
      window.location.href=changePwdUrl
    },
    jumpToPreventEmail(){
      window.location.href=emailPreserveUrl
    },
    handleAboutUs(){
        this.$router.push('/about-us')
    },
    logout() {
      window.location = baseUrl + "/login/logout";
    },
    goFeedback() {
      this.$router.push({
        path: "/appDetail",
        query: {
          url: feedbackUrl,
          title: "意见反馈",
        },
      });
    },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  font-size: 0.28rem;
  background: #FAFBFF;
}

.top {
  width: 100%;
  box-sizing: border-box;
  height: 1.4rem;
  background-image: url(../assets/images/top_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top:.3rem;
}
.top-row{
    position: relative;
    width:100%;
    height: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .36rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.top-row img {
  position: absolute;
  width: 0.22rem;
  height: 0.36rem;
  left: 0.23rem;
  top: 0.41rem;
  display: inline-block;
}

.main {
  width: 7.02rem;
  height: calc(100% - 1.88rem);
  background-color: #fff;
  border-radius: .20rem;
  margin:.24rem;
  box-sizing: border-box;
  padding:.14rem .44rem .4rem .41rem;
}

.setItem {
  width:100%;
  height: 1.22rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: .28rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #282828;
}
.setItem>img {
  width:.12rem;
  height: .22rem;
}
.setItem .left{
    display: flex;
    align-items: center;
}
.setItem .left img{
    width:.44rem;
    height: .44rem;
    margin-right: .3rem;
}
</style>
